import React from 'react';
import { FileText, Calendar, Search, Scale, HelpCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export function ServicesSection() {
  const navigate = useNavigate();

  const services = [
    {
      icon: <Calendar className="h-12 w-12 text-blue-600" />,
      title: "Book Appointment",
      description: "Schedule court appointments",
      path: "https://lagosjudiciary.gov.ng/schedule-e-swearing.html" 
    },
    {
      icon: <FileText className="h-12 w-12 text-blue-600" />,
      title: "Forms",
      description: "Download legal forms",
      path:"https://lagosjudiciary.gov.ng/forms.html"
    },
    {
      icon: <Scale className="h-12 w-12 text-blue-600" />,
      title: "LCIS",
      description: "Lagos Criminal Information System",
      path: "https://lcis.com.ng/" 
    },
    {
      icon: <Scale className="h-12 w-12 text-blue-600" />,
      title: "Small Claims Court",
      description: "File small claims cases",
      path:"https://lagoscomis.lagosjudiciary.gov.ng/returns_for_public.html"
    },
    {
      icon: <Search className="h-12 w-12 text-blue-600" />,
      title: "Online Search",
      description: "Search court records",
      path: "/online-search" // ✅ internal route
    },
    {
      icon: <HelpCircle className="h-12 w-12 text-blue-600" />,
      title: "E-Filing Help",
      description: "Get e-filing assistance",
      path:"https://lagosjudiciary.gov.ng/Accomplishment_Documents/LEGAL%20COUNSEL%20-%20User%20Manual%20-%20April.25.2022%20Ver5.0.pdf"
    }
  ];

  const handleClick = (path?: string) => {
    if (!path) return;
    if (path.startsWith("http")) {
      window.open(path, "_blank", "noopener,noreferrer");
    } else {
      navigate(path);
    }
  };

  return (
    <section className="bg-gray-50 dark:bg-gray-800 overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 max-w-7xl">
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-1 h-8 bg-orange-500"></div>
            <h2 className="text-3xl text-blue-900 dark:text-blue-300">How can we help?</h2>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 mb-4">
          {services.map((service, index) => (
            <div
              key={index}
              onClick={() => handleClick(service.path)}
              className="bg-white dark:bg-gray-700 rounded-lg p-6 text-center hover:shadow-lg transition-shadow cursor-pointer border border-gray-200 dark:border-gray-600"
            >
              <div className="flex justify-center mb-4">
                {service.icon}
              </div>
              <h3 className="text-blue-900 dark:text-blue-300 font-medium mb-2">
                {service.title}
              </h3>
              <p className="text-gray-600 dark:text-gray-400 text-sm">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}